export default {"src":"/_next/static/media/vg.186cfc4f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};